<!-- components/ControlFilters.vue -->
<template>
  <div class="card shadow-sm mb-4 border-top-primary no-print">
    <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center">
      <h5 class="mb-0 text-primary fw-bold">
        <i :class="icon" class="ms-2"></i> {{ title }}
      </h5>
    </div>

    <div class="card-body">
      <div class="row g-3 align-items-end">
        
        <!-- 1. الفصل الدراسي (يظهر إذا طلبته) -->
        <div class="col-md-3" v-if="show.term">
          <label class="form-label fw-bold small">الفصل الدراسي</label>
          <select v-model="form.term" @change="handleTermChange" class="form-select">
            <option value="">-- اختر --</option>
            <option v-for="t in lists.terms" :key="t.id" :value="t">{{ t.name }}</option>
          </select>
        </div>

        <!-- 2. الإدارة (يظهر إذا طلبته) -->
        <div class="col-md-3" v-if="show.admin">
          <label class="form-label fw-bold small">الإدارة التعليمية</label>
          <select v-model="form.admin"  @change="handleAdminChange" class="form-select">
            <option value="">-- اختر --</option>
            <option v-for="a in lists.admins" :key="a.id" :value="a.id">{{ a.dep_name }}</option>
          </select>
        </div>
        <div class="col-md-3" v-if="show.school">
          <label class="form-label fw-bold small"> المدرسة</label>
          <select v-model="form.school_id" class="form-select">
            <option value="">-- اختر --</option>
            <option v-for="a in lists.schools" :key="a.id" :value="a.id">{{ a.school_name }}</option>
          </select>
        </div>
        <div class="col-md-3" v-if="show.StudentType">
          <label class="form-label fw-bold small"> قيد الطالب</label>
          <select v-model="form.StudentType_id" class="form-select">
            <option value="">-- اختر --</option>
            <option v-for="Type in lists.StudentType" :key="Type.id" :value="Type.id">{{ Type.name }}</option>
          </select>
        </div>
        <div class="col-md-3" v-if="show.DamgStatus">
          <label class="form-label fw-bold small"> حالة الطالب</label>
          <select v-model="form.DamgStatus_id" class="form-select">
            <option value="">-- اختر --</option>
            <option v-for="Damg in lists.DamgStatus" :key="Damg.id" :value="Damg.id">{{ Damg.name }}</option>
          </select>
        </div>
        <div class="col-md-3" v-if="show.Nationality">
          <label class="form-label fw-bold small"> الجنسية</label>
          <select v-model="form.Nationality_id" class="form-select">
            <option value="">-- اختر --</option>
            <option v-for="National in lists.Nationality" :key="National.id" :value="National.id">{{ National.name }}</option>
          </select>
        </div>
        <div class="col-md-3" v-if="show.Moslem">
          <label class="form-label fw-bold small"> الديانة</label>
          <select v-model="form.Moslem_id" class="form-select">
            <option value="">-- اختر --</option>
            <option v-for="Mos in lists.Moslem" :key="Mos.id" :value="Mos.id">{{ Mos.name }}</option>
          </select>
        </div>
        <div class="col-md-3" v-if="show.committee">
          <label class="form-label fw-bold small">مقر اللجنة</label>
          <select v-model="form.committee_id" class="form-select">
            <option value="">-- اختر --</option>
            <option v-for="c in lists.committees" :key="c.id" :value="c.id">{{ c.commitee_name }}</option>
          </select>
        </div>
        <!-- 3. المواد (مرتبط بالترم) -->
        <div class="col-md-3" v-if="show.subject">
          <label class="form-label fw-bold small">المادة</label>
          <select v-model="form.subject" class="form-select" :disabled="!form.term">
            <option value="">-- اختر --</option>
            <option v-for="s in lists.subjects" :key="s.id" :value="s">{{ s.name }}</option>
          </select>
        </div>

        <!-- 4. المجموعات -->
        <div class="col-md-3" v-if="show.group">
          <label class="form-label fw-bold small">المجموعة</label>
          <select v-model="form.group" class="form-select">
            <option value="">-- اختر --</option>
            <option v-for="g in lists.groups" :key="g.id" :value="g.id">{{ g.group_name }}</option>
          </select>
        </div>

        <!-- 5. اللجان -->
       

        <!-- أزرار الإجراءات (ديناميكية) -->
        <div class="col-auto ms-auto d-flex gap-2">
          <!-- زر البحث/العرض -->
          <button @click="emitAction('search')" class="btn btn-warning fw-bold text-dark px-4" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
            <i class="fas fa-search ms-1" v-else></i> استعلام
          </button>
          
          <!-- زر الطباعة -->
          <button @click="emitAction('print')" class="btn btn-info text-white px-4">
            <i class="fas fa-print ms-1"></i> طباعة
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/axios'; // تأكد من المسار

export default {
  name: "ControlFilters",
  props: {
    title: { type: String, default: "بحث وتصفية" },
    icon: { type: String, default: "fas fa-filter" },
    loading: { type: Boolean, default: false },
    // نمرر مصفوفة بما نريد إظهاره: ['term', 'subject', 'group']
    visibleFilters: { type: Array, default: () => ['term', 'subject'] } 
  },
  data() {
    return {
      form: {
        term: "",
        admin: "",
        school_id: "",
        StudentType_id: "",
        DamgStatus_id: "",
        Moslem_id: "",
        Nationality_id: "",
        subject: "",
        group: "",
        committee_id: ""
      },
      lists: {
        terms: [],
        admins: [],
        schools: [],
        subjects: [],
        groups: [],
        committees: [],
        StudentType: [{id:1 , name:' نظامى'},{id:2 , name:'منازل '},{id:3 , name:'تحسين '}],
        DamgStatus: [{id:1 , name:'طلاب الدمج'},{id:2 , name:'طلاب اصحاء'}],
        Moslem: [{id:1 , name:' مسلم'},{id:2 , name:' مسيحى'}],
        Nationality: [{id:1 , name:'مصرى'},{id:2 , name:' غير مصرى'}],
      }
    };
    

  },
  computed: {
    // تحويل المصفوفة إلى كائن لسهولة الشرط v-if
    show() {
      return {
        term: this.visibleFilters.includes('term'),
        admin: this.visibleFilters.includes('admin'),
        subject: this.visibleFilters.includes('subject'),
        group: this.visibleFilters.includes('group'),
        committee: this.visibleFilters.includes('committee'),
        school: this.visibleFilters.includes('school'),
        StudentType: this.visibleFilters.includes('StudentType'),
        DamgStatus: this.visibleFilters.includes('DamgStatus'),
        Nationality: this.visibleFilters.includes('Nationality'),
        Moslem: this.visibleFilters.includes('Moslem'),



        




      };
    }
  },
  mounted() {
    this.loadInitialData();
  },
  methods: {
    async loadInitialData() {
      // تحميل البيانات بناءً على ما هو مطلوب فقط لتخفيف الحمل
      const promises = [];
      
      if (this.show.term) promises.push(api.get('/getterms').then(res => this.lists.terms = res.data));
      if (this.show.admin) promises.push(api.get('/getadmins').then(res => this.lists.admins = res.data));
      // if (this.show.admin) promises.push(api.get('/getschoolswithmange/' + this.form.admin_id).then(res => this.lists.schools = res.data));
      if (this.show.group) promises.push(api.get('/getgroups').then(res => this.lists.groups = res.data));
    //   if (this.show.committee) promises.push(api.get('/admin/getCommittee').then(res => this.lists.committees = res.data));

      await Promise.all(promises);
    },

    async handleTermChange() {
      // إذا تم تغيير الترم وكان حقل المواد مفعلاً، نجلب المواد
      if (this.show.subject && this.form.term) {
        this.form.subject = ""; // تصفير المادة القديمة
        try {
          const res = await api.get('/getSubject/' + this.form.term['id'] );
          this.lists.subjects = res.data;
        } catch (e) { console.error(e); }
      }
      
      // إرسال التحديث للأب فوراً في حال أراد عمل شيء
      this.$emit('change', this.form);
    },
    async handleAdminChange() {
   
      // إذا تم تغيير الترم وكان حقل المواد مفعلاً، نجلب المواد
      if (this.show.school && this.form.admin) {
     
        try {
          const res = await api.get('/getschoolswithmange/' + this.form.admin );
         this.lists.schools = res.data
        } catch (e) { console.error(e); }
      }
      
      // إرسال التحديث للأب فوراً في حال أراد عمل شيء
      this.$emit('change', this.form);
    },

    emitAction(actionName) {
      // إرسال البيانات المختارة للأب
      this.$emit(actionName, this.form);
    }
  }
};
</script>

<style scoped>
.border-top-primary { border-top: 4px solid #0d6efd; }
</style>